import { render } from "./OpinionListAll.vue?vue&type=template&id=58bba634&scoped=true"
import script from "./OpinionListAll.vue?vue&type=script&lang=js"
export * from "./OpinionListAll.vue?vue&type=script&lang=js"

import "./OpinionListAll.vue?vue&type=style&index=0&id=58bba634&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bba634"]])

export default __exports__